import { render, staticRenderFns } from "./TokenPagesFooter.vue?vue&type=template&id=fe3c6c64&scoped=true&"
import script from "./TokenPagesFooter.vue?vue&type=script&lang=js&"
export * from "./TokenPagesFooter.vue?vue&type=script&lang=js&"
import style0 from "./TokenPagesFooter.vue?vue&type=style&index=0&id=fe3c6c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3c6c64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
